const valueAsPercentage = ({ value, min, max }) =>
  ((Number(value) - Number(min)) * 100) / (Number(max) - Number(min));

const percentageAsValue = ({ percentage, min, max }) =>
  (Number(percentage) * (Number(max) - Number(min))) / 100 + Number(min);

export { valueAsPercentage, percentageAsValue };
